// import { RestoreUsersAction, UnblockUsersAction } from "store/middlewares/user";
import { Menu, MenuItem } from "@mui/material";
import { MuiBox, MuiTypography } from "components/atoms";
import React, { useState } from "react";
import { Button } from "components/ui";
import { EllipsisVertical, Info } from "lucide-react";

import { useNavigate } from "react-router-dom";

const AnnouncementActionBar = ({ row }) => {
  const navigate = useNavigate();
  //--------------------------------------------------- Action Menu Array --------------------------------------
  const ActionMenuArray = [
    {
      label: "Users",
      icon: <Info size={16} color="#475569" />,
      onClick: () => {
        navigate(`/announcement/${row.id}`);
      },
    },
  ].filter(Boolean);

  // For action menu
  const [actionMenu, setActionMenu] = useState(null);
  const handleActionMenuOpen = (event) => {
    setActionMenu(event.currentTarget);
  };
  const handleActionMenuClose = () => {
    setActionMenu(null);
  };

  return (
    <MuiBox className="flex h-full items-center justify-center gap-3 ">
      <Button
        className="size-7"
        mode="icon"
        variant="ghost"
        onClick={handleActionMenuOpen}
      >
        <EllipsisVertical />
      </Button>

      <Menu
        anchorEl={actionMenu}
        open={Boolean(actionMenu)}
        onClose={() => handleActionMenuClose(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{
          " & .MuiMenu-paper": {
            mt: "10px",
            background: " size-4 z-0 #fff",
            boxShadow:
              " 0 4px 6px -1px #e2e8f0, 0 2px 4px -2px #e2e8f0 !important",
          },
        }}
      >
        {ActionMenuArray.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => {
              handleActionMenuClose();
              option.onClick();
            }}
          >
            <MuiBox
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "9px",
              }}
            >
              <MuiBox sx={{ width: "fit-content" }}>{option.icon}</MuiBox>
              <MuiTypography
                sx={{ fontWeight: "500", fontSize: "13px", color: "#475569" }}
              >
                {option.label}
              </MuiTypography>
            </MuiBox>
          </MenuItem>
        ))}
      </Menu>
    </MuiBox>
  );
};

export default AnnouncementActionBar;
